module.exports = __webpack_public_path__ + "img/sGolWest_350x350.388c5ca9.jpg";